/**
 * cart-bundle.js
 * Handles bundle item quantity sync and removal on the cart page.
 * All bundle items share the same _bundle_id property. When the
 * parent quantity changes, every child in the bundle is updated to
 * match. When the bundle is removed every member is set to 0.
 */
(function () {
  'use strict';

  /* ---------------------------------------------------------------
   * removeBundleItems(bundleId)
   * Called by the onclick attribute on the bundle remove button.
   * Fetches the live cart, zeroes every item whose _bundle_id
   * matches, then reloads the page.
   * --------------------------------------------------------------- */
  window.removeBundleItems = async function (bundleId) {
    if (!bundleId) return;

    // Show loading state on the parent cart-item card
    var parentCard = document.querySelector('[data-bundle-id="' + bundleId + '"]');
    if (parentCard) parentCard.classList.add('is-loading');

    try {
      var cartResponse = await fetch('/cart.js');
      var cart = await cartResponse.json();

      var updates = {};
      cart.items.forEach(function (item) {
        if (item.properties && item.properties._bundle_id === bundleId) {
          updates[item.key] = 0;
        }
      });

      if (Object.keys(updates).length === 0) {
        // Nothing matched — just reload to reflect real cart state
        window.location.reload();
        return;
      }

      var response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates }),
      });

      if (response.ok) {
        window.location.reload();
      } else {
        throw new Error('Cart update failed: ' + response.status);
      }
    } catch (err) {
      console.error('[cart-bundle] removeBundleItems error:', err);
      if (parentCard) parentCard.classList.remove('is-loading');
    }
  };

  /* ---------------------------------------------------------------
   * Bundle quantity change via +/- buttons
   * Listens for clicks on .is--minus / .is--plus inside any element
   * with [data-bundle-wrapper]. Updates ALL cart items that share
   * the same _bundle_id to the new quantity, then reloads.
   * --------------------------------------------------------------- */
  document.addEventListener('click', async function (e) {
    // Only care about clicks inside a bundle quantity wrapper
    var wrapper = e.target.closest('[data-bundle-wrapper]');
    if (!wrapper) return;

    var isMinusBtn = !!e.target.closest('.is--minus');
    var isPlusBtn = !!e.target.closest('.is--plus');
    if (!isMinusBtn && !isPlusBtn) return;

    e.preventDefault();
    e.stopPropagation();

    var bundleId = wrapper.getAttribute('data-bundle-wrapper');
    var mainInput = wrapper.querySelector('.main-item-qty');
    if (!mainInput || !bundleId) return;

    var currentQty = parseInt(mainInput.value, 10) || 1;
    var minQty = parseInt(mainInput.getAttribute('min'), 10) || 1;
    var maxQty = parseInt(mainInput.getAttribute('data-max') || mainInput.getAttribute('max'), 10) || 9999;

    var newQty = currentQty;
    if (isMinusBtn) {
      newQty = Math.max(minQty, currentQty - 1);
    } else {
      newQty = Math.min(maxQty, currentQty + 1);
    }

    if (newQty === currentQty) return;

    // If qty reaches 0, remove the whole bundle
    if (newQty === 0) {
      window.removeBundleItems(bundleId);
      return;
    }

    // Optimistic UI update
    mainInput.value = newQty;

    var cartItem = wrapper.closest('.cart-item');
    if (cartItem) cartItem.classList.add('is-loading');

    try {
      var cartResponse = await fetch('/cart.js');
      var cart = await cartResponse.json();

      var updates = {};
      cart.items.forEach(function (item) {
        if (item.properties && item.properties._bundle_id === bundleId) {
          updates[item.key] = newQty;
        }
      });

      if (Object.keys(updates).length === 0) {
        // Bundle not found in cart — revert and reload
        mainInput.value = currentQty;
        if (cartItem) cartItem.classList.remove('is-loading');
        window.location.reload();
        return;
      }

      var response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates }),
      });

      if (response.ok) {
        window.location.reload();
      } else {
        throw new Error('Cart update failed: ' + response.status);
      }
    } catch (err) {
      console.error('[cart-bundle] quantity update error:', err);
      // Revert optimistic update
      mainInput.value = currentQty;
      if (cartItem) cartItem.classList.remove('is-loading');
    }
  });
})();
